import { publicApi } from './apis';
import { ConfigEnvironmentVariableLinksResponseInterface } from '@types';

const ROUTES = {
  config: '/config',
};

export const getAppConfig = async (): Promise<ConfigEnvironmentVariableLinksResponseInterface> => {
  const response = await publicApi.get<ConfigEnvironmentVariableLinksResponseInterface>(
    ROUTES.config
  );
  return response.data;
};
